import { useInfiniteQuery } from 'hooks/useInfiniteQuery'

import { fetchPosts } from 'utils/queries'

import { Post, PostFilter } from 'types/post'

export const useInfinitePosts = ({
  creatorId,
  premium,
  order = 'created',
  shouldIncludeDrafts = false,
  limit = 10,
  filter,
}: {
  creatorId?: string | string[]
  premium?: boolean
  order?: keyof Post
  shouldIncludeDrafts?: boolean
  limit?: number
  filter?: PostFilter
}) => {
  return useInfiniteQuery<Array<Post>>(
    ['posts', creatorId, order, premium, shouldIncludeDrafts, limit, filter],
    ({ pageParam }) => {
      return fetchPosts(
        {
          creatorId,
          premium,
          shouldIncludeDrafts,
          filter,
        },
        { order, orderDirection: 'desc', lastVisible: pageParam, limit },
      )
    },
    {
      getNextPageParam: (lastPage) => {
        // Very important, as the last page might not have any results
        if (!lastPage || !lastPage.length) return undefined

        return lastPage[lastPage.length - 1][order]
      },
      refetchInterval: 60000,
      staleTime: 30000,
    },
  )
}
